import React, { Component } from 'react';
import './DSRForm.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../Common/Loader/Loader';
import {
  Modal,
  InlineNotification,
  NotificationActionButton,
  Dropdown,
  Button,
  Link,
  ToastNotification,
  FormLabel,
  Tooltip,
  TextInput,
  TextArea,
} from 'carbon-components-react';
import { CONST } from '../shared/app.constant';
import Helper from '../shared/common.helper';
import LoginWindow from '../Common/LoginForms/LoginWindow';
import OtpComponent from '../Common/LoginForms/OtpComponent';
import { jwtDecode } from 'jwt-decode';
import getEnv from '../shared/environment';

var t = {};
var cc_lc;
var fetchedUrl = getEnv();
class DsrComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoader: true,
      loginWindow: 0,
      notification: 0,
      loginURL: CONST.LOGIN_URL_DSR_FORM,
      isAuthenticated: false,
      userData: Helper.userData(),
      userEmailAddress: null,
      authorisedEmail: null,
      subjectEmail: null,
      ibmEmailaddress: '',
      lastName: '',
      firstName: '',
      otherName: '',
      confirmEmailAddress: '',
      authconfirmEmailAddress: '',
      emailAddress: '',
      inputSerialNum: '',
      serialNum: null,
      intranetemailID: null,
      dateOfbirth: null,
      startDate: '',
      enableButton: true,
      isFrom: '',
      isChecked: false,
      isLoggedIn: false,
      isTwoFactorFailed: false,
      isFromTwofactor: false,
      failureCounter: 0,
      countryList: [],
      countrySelect: '',
      stateList: [],
      stateSelect: '',
      dataFlow: 0,
      requestorType: '',
      requestType: '',
      requestTypeTextArea: false,
      requestTypeDropdown: false,
      additionalInfo: '',
      requestTypeSubject: null,
      additionalInformation: '',
      salutation: '',
      twoFactorData: {
        emailAddress: '',
        randomCode: '',
      },
      isAutoPopulate: false,
      wardCountStart: 0,
      wardCountStartAi: 0,
      isGetUserData: false,
      cmtResponse: '',
      open: 'false',
      isModelOpen: false,
      createdCaseNo: '',
    };
    this.fetchTranslation();
  }

  fetchTranslation = () => {
    cc_lc = 'us-en';
    t = require('../locale/us-en.json');
  };

  componentDidMount() {
    this.fetchCountry();
    document.title = CONST.PAGE_TITLE.DSR;
    setTimeout(() => {
      this.checkSessionExists();
    }, 1800);
  }
  // fetchCountry = () => {
  //   var countryUrl = CONST.ENV_URL + '/country/' + cc_lc;
  //   fetch(countryUrl)
  //     .then((response) => {
  //       if (response.ok) {
  //         response.json().then((json) => {
  //           this.setState({
  //             countryList: json.data.data,
  //           });
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };
  fetchCountry = () => {
    fetch(fetchedUrl + '/country/' + cc_lc)
      .then((response) => {
        if (!response.ok) {
          throw new Error('country list fetch error');
        }
        return response.json(); // Parse the JSON response
      })
      .then((data) => {
        this.setState({
          countryList: data.data,
        });
      })
      .catch((error) => {
        console.error('An error occurred:', error);
      });
  };
  countryChange = (e) => {
    this.setState({
      stateList: [],
      stateSelect: '',
    });
    if (e.id === CONST.COUNTRY_US || e.id === CONST.COUNTRY_CAN) {
      this.setState({
        stateList: e.states,
      });
    }
    this.setState(
      {
        countrySelect: e,
      },
      () => {
        this.formValidation();
      },
    );
  };

  stateChange = (e) => {
    this.setState(
      {
        stateSelect: e,
      },
      () => {
        this.formValidation();
      },
    );
  };

  checkSessionExists() {
    const idaasUrl = 'https://login.ibm.com/v1/mgmt/idaas/user/status';
    fetch(idaasUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((resp) => {
        resp.json().then((json) => {
          let isUserAuthendicated = false;
          if (json && json.user && json.uniqueSecurityName) {
            isUserAuthendicated = true;
            this.setState((prevState) => ({
              isAuthenticated: isUserAuthendicated,
              userEmailAddress: json.user,
              isLoader: false,
              userData: {
                ...prevState.userData,
                passport: json,
              },
            }));
            this.getNextGenData(json);
          } else {
            this.setState({ isLoader: false });
          }
        });
      })
      .catch((error) => {
        this.setState({ isLoader: false });
      });
  }

  getNextGenData(passport) {
    if (passport && passport.uniqueSecurityName) {
      const data = JSON.stringify({
        uniqueName: Helper.encryptString(passport.uniqueSecurityName),
      });
      var nextgenUrl = fetchedUrl + '/user/nextgen';
      fetch(nextgenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: data,
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              if (json && json.data) {
                this.autoPopulate(json.data);
                this.getUserData(json.data.userName);
                this.setState((preState) => ({
                  userData: {
                    ...preState.userData,
                    nextgen: json.data,
                  },
                  isLoggedIn: true,
                  loginWindow: 2,
                }));
              }
            });
          }
        })
        .catch((error) => {
          console.error('An error occurred:', error);
        });
    }
  }
  getUserData(emailAddress) {
    if (emailAddress) {
      const queryURL = `https://api-proxy-unified-dsr-form.1kkdszd12iqm.us-east.codeengine.appdomain.cloud/?query=${encodeURIComponent(
        `[user_id]=${emailAddress}`,
      )}`;
      fetch(queryURL, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        credentials: 'include',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network error');
          }
          return response.json();
        })
        .then((data) => {
          if (data) {
            if (
              this.state.serialNum === null &&
              this.state.intranetemailID === null
            ) {
              this.setState({
                serialNum: data.userId,
                intranetemailID: data.content.mail[0],
                isGetUserData: true,
              });
            }
          }
        })
        .catch((error) => {
          console.error('An error occurred:', error);
        });
    }
  }
  autoPopulate = (data) => {
    this.setState({
      confirmEmailAddress: data.userName,
      emailAddress: data.userName,
      firstName: data.givenName,
      lastName: data.familyName,
      isAutoPopulate: true,
    });
  };

  generateTwoFactorCode(userEmailAddress) {
    this.setState({ userEmailAddress: userEmailAddress });
    const apiUrl = fetchedUrl + '/dsr/2fa/generate';
    const data = JSON.stringify({
      emailAddress: Helper.encryptString(userEmailAddress),
      cclc: cc_lc,
    });
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    };
    fetch(apiUrl, config)
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            const decoded = jwtDecode(json.data);
            this.setState((preState) => ({
              ...preState,
              loginWindow: 1,
              twoFactorData: {
                emailAddress: decoded.emailAddress,
                randomCode: decoded.randomCode,
              },
            }));
          });
        }
      })
      .catch(function (response) {
        console.error('An error occurred:', response);
      });
  }

  verifyTowFactorCode(e, authCode) {
    const { twoFactorData } = this.state;
    if (authCode === twoFactorData.randomCode) {
      this.setState((preState) => ({
        ...preState,
        loginWindow: 2,
        isUserLoggedIn: true,
        isFromTwofactor: true,
        isTwoFactorFailed: false,
      }));
    } else {
      this.setState({
        isTwoFactorFailed: true,
      });
    }
  }

  closeModal = () => {
    this.setState((prevState) => ({
      modelOptions: {
        ...prevState.modelOptions,
        isModelOpen: false,
      },
    }));
  };

  firstNameChange = (e) => {
    this.setState(
      {
        firstName: e.target.value,
      },
      () => {
        this.formValidation();
      },
    );
  };
  lastNameChange = (e) => {
    this.setState(
      {
        lastName: e.target.value,
      },
      () => {
        this.formValidation();
      },
    );
  };
  otherNameChange = (e) => {
    this.setState({
      otherName: e.target.value,
    });
  };
  emailChange = (e) => {
    this.setState(
      {
        emailAddress: e.target.value,
      },
      () => {
        this.formValidation();
      },
    );
  };
  confirmEmailChange = (e) => {
    this.setState(
      {
        confirmEmailAddress: e.target.value,
      },
      () => {
        this.formValidation();
      },
    );
  };
  confirmauthEmailChange = (e) => {
    this.setState(
      {
        authconfirmEmailAddress: e.target.value,
      },
      () => {
        this.formValidation();
      },
    );
  };
  talentIdChange = (e) => {
    this.setState({
      serialNum: e.target.value,
    });
  };

  handleDateVal = (e) => {
    let d = new Date(e);
    let monthName = ('0' + (d.getMonth() + 1)).slice(-2);
    d = new Date(e);
    let dayVal = ('0' + d.getDate()).slice(-2);
    var dateVal = `${dayVal}` + '/' + `${monthName}`;
    this.setState(
      {
        dateOfbirth: dateVal,
        startDate: e,
      },
      () => {
        this.formValidation();
      },
    );
  };

  othertalentIdChange = (e) => {
    this.setState({
      inputSerialNum: e.target.value,
    });
  };
  formValidation = () => {
    const {
      firstName,
      lastName,
      confirmEmailAddress,
      emailAddress,
      countrySelect,
      stateSelect,
      userEmailAddress,
      authorisedEmail,
      subjectEmail,
      requestorType,
      authconfirmEmailAddress,
      dateOfbirth,
    } = this.state;
    let count = 0;
    if (firstName && firstName.trim()) {
      count++;
    }
    if (lastName && lastName.trim()) {
      count++;
    }
    if (
      (emailAddress &&
        Helper.validateEmail(emailAddress) &&
        emailAddress.trim()) ||
      (userEmailAddress && userEmailAddress.trim()) ||
      (subjectEmail && subjectEmail.trim()) ||
      (authorisedEmail && authorisedEmail.trim())
    ) {
      count++;
    }
    if (
      (confirmEmailAddress &&
        Helper.validateEmail(confirmEmailAddress) &&
        confirmEmailAddress.trim()) ||
      (authconfirmEmailAddress && authconfirmEmailAddress)
    ) {
      count++;
    }
    if (
      (emailAddress &&
        emailAddress.trim().toString().toLowerCase() ===
          confirmEmailAddress.trim().toString().toLowerCase()) ||
      (userEmailAddress &&
        userEmailAddress.trim().toString().toLowerCase() ===
          confirmEmailAddress.trim().toString().toLowerCase()) ||
      (subjectEmail &&
        subjectEmail.trim().toString().toLowerCase() ===
          confirmEmailAddress.trim().toString().toLowerCase() &&
        authorisedEmail &&
        authorisedEmail.trim().toString().toLowerCase() ===
          authconfirmEmailAddress.trim().toString().toLowerCase())
    ) {
      count++;
    }
    // country
    if (
      (countrySelect &&
        countrySelect.id !== CONST.COUNTRY_US &&
        countrySelect.id !== CONST.COUNTRY_CAN) ||
      (countrySelect &&
        (countrySelect.id === CONST.COUNTRY_US ||
          countrySelect.id === CONST.COUNTRY_CAN) &&
        stateSelect)
    ) {
      count++;
    }
    if (
      (requestorType !== 'Employee' &&
        (requestorType === 'Former Employee' ||
          (!authorisedEmail && requestorType === 'Prospective IBM Employee')) &&
        dateOfbirth !== 'aN/aN' &&
        dateOfbirth !== null &&
        dateOfbirth !== undefined &&
        dateOfbirth !== '') ||
      (authorisedEmail && requestorType === 'Prospective IBM Employee') ||
      (requestorType === 'Employee' &&
        (requestorType !== 'Former Employee' ||
          requestorType !== 'IBM Customer / IBM Prospect' ||
          requestorType !== 'Prospective IBM Employee' ||
          requestorType !== 'IBM.com account owner' ||
          requestorType !== 'Vendor')) ||
      (requestorType === 'IBM Customer / IBM Prospect' &&
        (requestorType !== 'IBM Business Partner / Reseller' ||
          requestorType !== 'IBM.com account owner' ||
          requestorType !== 'Vendor')) ||
      (requestorType === 'Vendor' &&
        (requestorType !== 'IBM Business Partner / Reseller' ||
          requestorType !== 'IBM.com account owner' ||
          requestorType !== 'IBM Customer / IBM Prospect')) ||
      (requestorType === 'IBM Business Partner / Reseller' &&
        (requestorType !== 'Vendor' ||
          requestorType !== 'IBM.com account owner' ||
          requestorType !== 'IBM Customer / IBM Prospect')) ||
      (requestorType === 'IBM.com account owner' &&
        (requestorType !== 'Vendor' ||
          requestorType !== 'IBM Business Partner / Reseller' ||
          requestorType !== 'IBM Customer / IBM Prospect'))
    ) {
      count = count;
    } else {
      count = 5;
    }
    return count === 6
      ? this.setState({ enableButton: false })
      : this.setState({ enableButton: true });
  };

  cancelForm() {
    window.location.reload();
  }

  handleDataRightsRequestForm = (e) => {
    e.preventDefault();
    this.setState({ isLoader: true, cmtResponse: null });
    const {
      requestorType,
      requestType,
      firstName,
      lastName,
      otherName,
      confirmEmailAddress,
      authorisedEmail,
      subjectEmail,
      userEmailAddress,
      countrySelect,
      stateSelect,
      requestTypeSubject,
      additionalInfo,
      additionalInformation,
      salutation,
      dateOfbirth,
      intranetemailID,
      serialNum,
      inputSerialNum,
      ibmEmailaddress,
      isFromTwofactor,
    } = this.state;
    const payload = JSON.stringify({
      salutation: salutation,
      firstName: Helper.encryptString(firstName),
      lastName: Helper.encryptString(lastName),
      otherName: Helper.encryptString(otherName),
      emailAddress:
        authorisedEmail === null || authorisedEmail === ''
          ? Helper.encryptString(userEmailAddress)
          : Helper.encryptString(subjectEmail),
      confirmEmailAddress: Helper.encryptString(confirmEmailAddress),
      subjectEmail: Helper.encryptString(subjectEmail),
      countryRegion: countrySelect,
      state: stateSelect,
      additionalInformation: additionalInformation,
      requestType: requestType,
      requestorType: requestorType,
      additionalInfo: additionalInfo,
      serialNum: serialNum, //IBM TalentID
      intranetemailID: intranetemailID, //IBM email address
      inputSerialNum: inputSerialNum, //IBM TalentID(s)
      ibmEmailaddress: ibmEmailaddress, //IBM email address(es)
      cc: cc_lc,
      requestTypeSubject: requestTypeSubject,
      showInfo: true,
      isLoggedIn: isFromTwofactor === true ? false : true,
      dateOfbirth: dateOfbirth,
      isFromTwofactor: isFromTwofactor,
    });
    if (authorisedEmail) {
      payload.authorizedEmail = JSON.stringify(authorisedEmail);
    }
    var cmtUrl = fetchedUrl + '/cmt';
    fetch(cmtUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: payload,
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            this.setState((prevState) => ({
              isLoader: false,
              createdCaseNo: json.data.CaseIdentifier,
              isModelOpen: true,
              notification: 1,
            }));
          });
        }
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        this.setState((prevState) => ({
          isLoader: false,
          isModelOpen: true,
          notification: 2,
        }));
        window.scrollTo(0, 0);
      });
  };
  onChangeRelation = (e) => {
    this.setState(
      {
        requestorType: e.selectedItem.value,
        dataFlow: 1,
      },
      () => {
        this.formValidation();
      },
    );
  };
  onChangeRequestType = (e) => {
    this.setState(
      {
        requestType: e.selectedItem.value,
        requestTypeSubject: e.selectedItem.requestTypeSubject,
        dataFlow: 2,
        additionalInfo: '',
        wardCountStart: 0,
      },
      () => {
        if (
          e.selectedItem.id === 0 ||
          e.selectedItem.id === 1 ||
          e.selectedItem.id === 4
        ) {
          this.setState({
            requestTypeTextArea: true,
            requestTypeDropdown: false,
          });
        } else if (e.selectedItem.id === 3) {
          this.setState({
            requestTypeDropdown: true,
            requestTypeTextArea: false,
          });
        } else if (e.selectedItem.id === 2) {
          this.setState({
            requestTypeTextArea: false,
            requestTypeDropdown: false,
            dataFlow: 3,
          });
        }
      },
    );
  };
  onChangeSubRequestType = (e) => {
    this.setState({
      dataFlow: 3,
      requestTypeSubject: e.selectedItem.requestTypeSubject,
    });
  };
  onChangeAdditionalInfo = (e) => {
    this.setState({
      additionalInfo: e.target.value,
      wardCountStart: e.target.value.length,
    });
    if (e.target.value.length != '') {
      this.setState({
        dataFlow: 3,
      });
    } else {
      this.setState({
        dataFlow: 2,
      });
    }
  };
  onChangeAdditionalInformation = (e) => {
    this.setState({
      additionalInformation: e.target.value,
      wardCountStartAi: e.target.value.length,
    });
  };
  onChangeSalutation = (e) => {
    this.setState({
      salutation: e.selectedItem,
    });
  };
  ibmEmailaddressChange = (e) => {
    this.setState({
      ibmEmailaddress: e.target.value,
    });
  };
  ibmEmailChange = (e) => {
    this.setState({
      intranetemailID: e.target.value,
    });
  };

  closeModal = () => {
    this.setState({
      isModelOpen: false,
    });
    this.cancelForm();
  };

  render() {
    const relationshipwithIBM = [
      {
        id: 0,
        text: t.translations.dsr.yourReldropdown.option0,
        value: 'Employee',
      }, //dob not mandatory
      {
        id: 1,
        text: t.translations.dsr.yourReldropdown.option1,
        value: 'Former Employee',
      }, //dob mandatory
      {
        id: 2,
        text: t.translations.dsr.yourReldropdown.option2,
        value: 'Prospective IBM Employee',
      }, //dob is mand ,remove talent id and Other IBM TalentID(s),remove IBM email address & IBM email address(es)
      {
        id: 3,
        text: t.translations.dsr.yourReldropdown.option3,
        value: 'IBM Customer / IBM Prospect',
      }, //remove talent id and Other IBM TalentID(s),remove IBM email address & IBM email address(es) & dob
      {
        id: 4,
        text: t.translations.dsr.yourReldropdown.option4,
        value: 'Vendor',
      }, //like 4
      {
        id: 5,
        text: t.translations.dsr.yourReldropdown.option5,
        value: 'IBM Business Partner / Reseller',
      }, //like 4
      {
        id: 6,
        text: t.translations.dsr.yourReldropdown.option6,
        value: 'IBM.com account owner',
      }, //like 4
    ];

    const requestType = [
      {
        id: 0,
        text: t.translations.dsr.reqTypedropdown.option0,
        value: 'Access',
        requestTypeSubject: 0,
      }, //mand textarea
      {
        id: 1,
        text: t.translations.dsr.reqTypedropdown.option1,
        value: 'Rectification',
        requestTypeSubject: 1,
      }, //mand textarea
      {
        id: 2,
        text: t.translations.dsr.reqTypedropdown.option2,
        value: 'Erasure',
        requestTypeSubject: 2,
      }, //nothing
      {
        id: 3,
        text: t.translations.dsr.reqTypedropdown.option3,
        value: 'Erasure',
        requestTypeSubject: 3,
      }, //child option
      {
        id: 4,
        text: t.translations.dsr.reqTypedropdown.option4,
        value: 'Not Sent',
        requestTypeSubject: 4,
      }, //mand textarea
    ];

    const childRequestType = [
      {
        id: 0,
        text: t.translations.dsr.reqTypedropdown.childOptions.option5,
        requestTypeSubject: 5,
      },
      {
        id: 1,
        text: t.translations.dsr.reqTypedropdown.childOptions.option6,
        requestTypeSubject: 6,
      },
      {
        id: 2,
        text: t.translations.dsr.reqTypedropdown.childOptions.option7,
        requestTypeSubject: 7,
      },
      {
        id: 3,
        text: t.translations.dsr.reqTypedropdown.childOptions.option8,
        requestTypeSubject: 8,
      },
      {
        id: 4,
        text: t.translations.dsr.reqTypedropdown.childOptions.option9,
        requestTypeSubject: 9,
      },
    ];

    const salutations = [
      { id: 'Mr.', text: t.translations.dsr.form.salutation_mr },
      { id: 'Ms.', text: t.translations.dsr.form.salutation_ms },
      { id: 'Miss', text: t.translations.dsr.form.salutation_miss },
      { id: 'Mrs.', text: t.translations.dsr.form.salutation_mrs },
      { id: 'Dr.', text: t.translations.dsr.form.salutation_dr },
    ];

    const {
      dataFlow,
      requestTypeTextArea,
      requestTypeDropdown,
      additionalInfo,
      requestorType,
      isLoader,
      isTwoFactorFailed,
      isAutoPopulate,
      wardCountStart,
      wardCountStartAi,
      additionalInformation,
      isGetUserData,
    } = this.state;
    return (
      <div className="dsrForm widget-styles">
        {isLoader && <Loader />}
        {this.state.isModelOpen === true && this.state.notification === 1 && (
          <div>
            <Modal open="true" onRequestClose={() => this.closeModal()}>
              <InlineNotification
                kind="success"
                title={t.translations.dsr.successinfo}
                subtitle={`${t.translations.dsr.successmsg1} ${this.state.createdCaseNo} ${t.translations.dsr.successmsg2}`}
                actions={
                  <div>
                    <br></br>
                    <Link
                      href={
                        window.location.protocol +
                        '//' +
                        window.location.host +
                        '/privacy/requests/dsr/' +
                        cc_lc
                      }
                    >
                      {t.translations.dsr.successmsg3}
                    </Link>
                  </div>
                }
              />
            </Modal>
          </div>
        )}
        {this.state.isModelOpen === true && this.state.notification === 2 && (
          <div>
            <Modal open="true" onRequestClose={() => this.closeModal()}>
              <InlineNotification
                kind="error"
                title={t.translations.dsr.newerrormsg}
                subtitle={`${t.translations.dsr.newerrormsg1}`}
                actions={
                  <NotificationActionButton style={{ marginTop: '2rem' }}>
                    {
                      <Link
                        href={
                          window.location.protocol +
                          '//' +
                          window.location.host +
                          '/privacy/requests/contact/' +
                          cc_lc
                        }
                      >
                        {t.translations.dsr.newerrormsg2}
                      </Link>
                    }
                  </NotificationActionButton>
                }
              />
            </Modal>
          </div>
        )}
        <div className="bx--grid">
          {this.state.loginWindow === 0 && (
            <LoginWindow
              t={t.translations}
              loginURL={this.state.loginURL}
              isFrom={this.state.isFrom}
              pageUrl={window.location.href}
              userEmailAddress={this.state.userEmailAddress}
              authorisedEmail={this.state.authorisedEmail}
              subjectEmail={this.state.subjectEmail}
              onSubmitotpEmail={(e) => {
                this.setState((preState) => ({
                  ...preState,
                  loginWindow: 1,
                  userEmailAddress: e.data.userEmailAddress,
                  authorisedEmail: e.data.authorisedEmail,
                  subjectEmail: e.data.subjectEmail,
                  isFrom: e.data.isFrom,
                }));
                if (e && e.data && e.data.userEmailAddress) {
                  this.generateTwoFactorCode(e.data.userEmailAddress);
                } else {
                  this.generateTwoFactorCode(e.data.authorisedEmail);
                }
              }}
              onSubmitDSRModelForm={(modelData) => {
                this.setState((preState) => ({
                  ...preState,
                  userEmailAddress: modelData.data.email,
                  authorisedEmail: modelData.data.authorisedEmail,
                  subjectEmail: modelData.data.subjectEmail,
                  isFrom: modelData.data.isFrom,
                  loginWindow: 2,
                }));
              }}
            />
          )}
          {this.state.loginWindow === 1 && (
            <OtpComponent
              t={t.translations}
              onSubmitotpEmail={(data) => {
                this.verifyTowFactorCode(data.e, data.authCode);
              }}
              userEmailAddress={
                this.state.userEmailAddress
                  ? this.state.userEmailAddress
                  : this.state.authorisedEmail
              }
              isTwoFactorFailed={isTwoFactorFailed}
              isTwoFactorCodeGenerated={this.state.isTwoFactorCodeGenerated}
              onClickResendOtp={(e) => {
                if (e) {
                  this.setState((preState) => ({
                    ...preState,
                    isTwoFactorCodeGenerated: false,
                  }));
                  this.generateTwoFactorCode(this.state.userEmailAddress);
                }
              }}
              backToPage={(e) => {
                if (e) {
                  this.setState((preState) => ({
                    ...preState,
                    loginWindow: 0,
                    isTwoFactorFailed: false,
                    failureCounter: 0,
                    authorisedEmail: this.state.authorisedEmail,
                    userEmailAddress: this.state.userEmailAddress,
                    subjectEmail: this.state.subjectEmail,
                    isFrom: this.state.isFrom,
                  }));
                }
              }}
            />
          )}
          {this.state.loginWindow === 2 && (
            <div>
              <div className="bx--row">
                <div className="bx--col-lg-8">
                  <div className="formDiv">
                    <br />
                    <header>
                      <h3>{t.translations.dsr.dsrtitle}</h3>
                    </header>
                  </div>
                </div>
                <div className="bx--col-lg-8"></div>
              </div>
              <div className="bx--row">
                <div className="bx--col-sm-4 bx--col-lg-10">
                  <form id="dsrform" name="dsrform" method="post">
                    <div className="bx--row">
                      <div className="bx--col-lg-10 formDiv">
                        <p>
                          {t.translations.dsr.required}{' '}
                          <span className="required">*</span>
                        </p>
                        <br></br>
                        <a name="1">&nbsp;</a>
                        <h5 title="Your relationship with IBM">
                          <strong>
                            <span className="required">*&nbsp;</span>
                            {t.translations.dsr.yourRel}
                          </strong>
                        </h5>
                        <div className="Dropdownwidth">
                          <Dropdown
                            id="ibmrelation"
                            required
                            titleText={t.translations.dsr.choose}
                            onChange={(e) => this.onChangeRelation(e)}
                            label={t.translations.dsr.choose}
                            items={relationshipwithIBM}
                            invalid={!this.state.requestorType ? true : false}
                            itemToString={(item) => (item ? item.text : '')}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-lg-10 bx--space">
                        <a name="2">&nbsp;</a>
                        <h5 title="Type of request">
                          <strong>
                            <span className="required">*&nbsp;</span>
                            {t.translations.dsr.reqType}
                          </strong>
                        </h5>
                        <div className="Dropdownwidth">
                          <Dropdown
                            required
                            titleText={t.translations.dsr.choose}
                            label={t.translations.dsr.choose}
                            items={requestType}
                            id="requestType"
                            invalid={!requestType ? true : false}
                            itemToString={(item) => (item ? item.text : '')}
                            onChange={(e) => this.onChangeRequestType(e)}
                            disabled={dataFlow === 0 ? true : false}
                          />
                        </div>
                        <br />
                        {requestTypeDropdown && (
                          <div>
                            <Dropdown
                              titleText={t.translations.dsr.choose}
                              label={t.translations.dsr.choose}
                              items={childRequestType}
                              itemToString={(item) => (item ? item.text : '')}
                              onChange={(e) => this.onChangeSubRequestType(e)}
                            />
                          </div>
                        )}
                        <a name="3">&nbsp;</a>
                        {requestTypeTextArea && (
                          <div>
                            <h5 title="Request Details">
                              <strong>
                                <span className="required">*&nbsp;</span>
                                {t.translations.dsr.reqDetails}
                              </strong>
                            </h5>
                            <FormLabel className="wordCount_wrap">
                              {t.translations.dsr.reDetailsubtitle}{' '}
                              <span className="wordCount">
                                {wardCountStart}/250
                              </span>
                            </FormLabel>
                            <TextArea
                              helperText=""
                              rows={4}
                              cols={50}
                              maxLength={250}
                              id="text-area-1"
                              required
                              value={additionalInfo}
                              onChange={(e) => this.onChangeAdditionalInfo(e)}
                            />
                          </div>
                        )}
                        <br />
                      </div>
                    </div>
                    <a name="4">&nbsp;</a>
                    {dataFlow > 2 && (
                      <div>
                        <div className="bx--row">
                          <div className="bx--col-lg-8 bx--space">
                            <h5 id="d" title="Personal details">
                              <strong>{t.translations.dsr.formsubTitle}</strong>
                            </h5>
                            <br />
                            <div className="dropDown">
                              <Dropdown
                                titleText={t.translations.dsr.form.title1}
                                label={t.translations.dsr.choose}
                                items={salutations}
                                itemToString={(item) => (item ? item.text : '')}
                                onChange={(e) => this.onChangeSalutation(e)}
                              />
                            </div>
                            <br />
                          </div>
                        </div>
                        {/* Firtsname ********* lastname row */}
                        <div className="bx--row">
                          <div className="bx--col-lg-8 bx--space firstName">
                            <FormLabel>
                              <span className="required">*&nbsp;</span>
                              <Tooltip
                                tabIndex={-1}
                                direction="bottom"
                                triggerText={
                                  !this.state.authorisedEmail
                                    ? t.translations.dsr.form.title2
                                    : t.translations.dsr.datasubjectForm.title1
                                }
                              >
                                <p className="tooltipAlign">
                                  {t.translations.infoMessage.content1}
                                  <Link
                                    title={t.translations.infoMessage.link}
                                    href="https://www.ibm.com/ibmweb/myibm/us-en/profile"
                                  >
                                    {t.translations.infoMessage.link}
                                  </Link>
                                  {t.translations.infoMessage.content2}
                                </p>
                              </Tooltip>
                            </FormLabel>
                            <TextInput
                              tabIndex={0}
                              labelText=""
                              autoComplete="off"
                              required
                              id="firstName"
                              placeholder={t.translations.dsr.form.title2}
                              invalid={!this.state.firstName ? true : false}
                              value={this.state.firstName}
                              onChange={(e) => this.firstNameChange(e)}
                              disabled={
                                this.state.firstName && isAutoPopulate
                                  ? true
                                  : false
                              }
                            />
                          </div>
                          <div className="bx--col-lg-8 bx--space firstName">
                            <FormLabel>
                              <span className="required">*&nbsp;</span>
                              <Tooltip
                                tabIndex={-1}
                                direction="bottom"
                                triggerText={
                                  !this.state.authorisedEmail
                                    ? t.translations.dsr.form.title3
                                    : t.translations.dsr.datasubjectForm.title2
                                }
                              >
                                <p className="tooltipAlign">
                                  {t.translations.infoMessage.content1}
                                  <Link
                                    title={t.translations.infoMessage.link}
                                    href="https://www.ibm.com/ibmweb/myibm/us-en/profile"
                                  >
                                    {t.translations.infoMessage.link}
                                  </Link>
                                  {t.translations.infoMessage.content2}
                                </p>
                              </Tooltip>
                            </FormLabel>
                            <TextInput
                              tabIndex={0}
                              labelText=""
                              autoComplete="off"
                              required
                              id="lastName"
                              placeholder={t.translations.dsr.form.title3}
                              invalid={!this.state.lastName ? true : false}
                              value={this.state.lastName}
                              onChange={(e) => this.lastNameChange(e)}
                              disabled={
                                this.state.lastName && isAutoPopulate
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        </div>
                        {/* Other Name ********* Date of birth row */}
                        {(requestorType === 'Employee' ||
                          requestorType === 'Former Employee' ||
                          requestorType === 'Prospective IBM Employee') && (
                          <div className="bx--row">
                            <div
                              className="bx--col-lg-8 bx--space firstName"
                              id="OtherDob"
                            >
                              <FormLabel>
                                <Tooltip
                                  tabIndex={-1}
                                  direction="bottom"
                                  triggerText={
                                    !this.state.authorisedEmail
                                      ? t.translations.dsr.form.title14
                                      : t.translations.dsr.datasubjectForm
                                          .title13
                                  }
                                >
                                  <p className="tooltipAlign">
                                    {t.translations.tooltipOthername}
                                  </p>
                                </Tooltip>
                              </FormLabel>
                              <TextInput
                                tabIndex={0}
                                autoComplete="off"
                                id="otherName"
                                placeholder={t.translations.dsr.form.title14}
                                value={this.state.otherName}
                                onChange={(e) => this.otherNameChange(e)}
                              />
                            </div>
                            <div
                              className="bx--col-lg-8 bx--space authorDiv"
                              id="OtherDob1"
                            >
                              <FormLabel>
                                {(((this.state.isLoggedIn ||
                                  (this.state.isFromTwofactor &&
                                    !this.state.authorisedEmail)) &&
                                  requestorType !== 'Employee' &&
                                  (requestorType === 'Former Employee' ||
                                    requestorType ===
                                      'Prospective IBM Employee')) ||
                                  ((!this.state.isLoggedIn ||
                                    (this.state.isFromTwofactor &&
                                      this.state.authorisedEmail)) &&
                                    requestorType !== 'Employee' &&
                                    requestorType === 'Former Employee' &&
                                    requestorType !==
                                      'Prospective IBM Employee')) && (
                                  <span className="required">*&nbsp;</span>
                                )}
                                {!this.state.authorisedEmail && (
                                  <span>{t.translations.dsr.form.title13}</span>
                                )}
                                {this.state.authorisedEmail && (
                                  <span>
                                    {t.translations.dsr.datasubjectForm.title12}
                                  </span>
                                )}
                              </FormLabel>
                              <br></br>
                              <DatePicker
                                selected={this.state.startDate}
                                dateFormat="dd/MM"
                                placeholderText={
                                  t.translations.dsr.form.datePlaceholder
                                }
                                id="dateOfbirth"
                                showMonthYearPicker
                                onChange={(e) => {
                                  this.handleDateVal(e);
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {/* Email Address ********* confirm email address row */}
                        <div className="bx--row">
                          <div className="bx--col-lg-8 bx--space firstName">
                            <FormLabel>
                              <span className="required">*&nbsp;</span>
                              {!this.state.authorisedEmail && (
                                <Tooltip
                                  tabIndex={-1}
                                  direction="bottom"
                                  triggerText={t.translations.dsr.form.title4}
                                >
                                  <p className="tooltipAlign">
                                    {t.translations.infoMessage.content1}
                                    <Link
                                      title={t.translations.infoMessage.link}
                                      href="https://www.ibm.com/ibmweb/myibm/us-en/profile"
                                    >
                                      {t.translations.infoMessage.link}
                                    </Link>
                                    {t.translations.infoMessage.content2}
                                  </p>
                                </Tooltip>
                              )}
                              {this.state.authorisedEmail && (
                                <Tooltip
                                  tabIndex={-1}
                                  direction="bottom"
                                  triggerText={
                                    t.translations.dsr.datasubjectForm.title3
                                  }
                                >
                                  <p className="tooltipAlign">
                                    {t.translations.infoMessage.content1}
                                    <Link
                                      title={t.translations.infoMessage.link}
                                      href="https://www.ibm.com/ibmweb/myibm/us-en/profile"
                                    >
                                      {t.translations.infoMessage.link}
                                    </Link>
                                    {t.translations.infoMessage.content2}
                                  </p>
                                </Tooltip>
                              )}
                            </FormLabel>
                            {!this.state.authorisedEmail && (
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                type="email"
                                autoComplete="off"
                                required
                                id="userEmailAddress"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                disabled={
                                  this.state.userEmailAddress ? true : false
                                }
                                invalid={
                                  !this.state.userEmailAddress.length === 0 ||
                                  !Helper.validateEmail(
                                    this.state.userEmailAddress,
                                  )
                                    ? true
                                    : false
                                }
                                value={this.state.userEmailAddress}
                                onChange={(e) => this.emailChange(e)}
                              />
                            )}
                            {this.state.authorisedEmail && (
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                type="email"
                                autoComplete="off"
                                required
                                id="emailAddress"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                disabled={
                                  this.state.subjectEmail ? true : false
                                }
                                value={this.state.subjectEmail}
                                invalid={
                                  !this.state.subjectEmail.length === 0 ||
                                  !Helper.validateEmail(this.state.subjectEmail)
                                    ? true
                                    : false
                                }
                                onChange={(e) => this.emailChange(e)}
                              />
                            )}
                          </div>
                          <div className="bx--col-lg-8 bx--space firstName">
                            <FormLabel>
                              <span className="required">*&nbsp;</span>
                              {!this.state.authorisedEmail && (
                                <Tooltip
                                  tabIndex={-1}
                                  direction="bottom"
                                  triggerText={t.translations.dsr.form.title5}
                                >
                                  <p className="tooltipAlign">
                                    {t.translations.infoMessage.content1}
                                    <Link href="https://www.ibm.com/ibmweb/myibm/us-en/profile">
                                      {t.translations.infoMessage.link}
                                    </Link>
                                    {t.translations.infoMessage.content2}
                                  </p>
                                </Tooltip>
                              )}
                              {this.state.authorisedEmail && (
                                <Tooltip
                                  tabIndex={-1}
                                  direction="bottom"
                                  triggerText={
                                    t.translations.dsr.datasubjectForm.title4
                                  }
                                >
                                  <p className="tooltipAlign">
                                    {t.translations.infoMessage.content1}
                                    <Link href="https://www.ibm.com/ibmweb/myibm/us-en/profile">
                                      {t.translations.infoMessage.link}
                                    </Link>
                                    {t.translations.infoMessage.content2}
                                  </p>
                                </Tooltip>
                              )}
                            </FormLabel>
                            {!this.state.authorisedEmail && (
                              <TextInput
                                tabIndex={0}
                                type="email"
                                labelText=""
                                autoComplete="off"
                                required
                                id="confirmEmailAddress"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                value={this.state.confirmEmailAddress}
                                invalid={
                                  !this.state.confirmEmailAddress.length ===
                                    0 ||
                                  this.state.userEmailAddress
                                    .trim()
                                    .toString()
                                    .toLowerCase() !==
                                    this.state.confirmEmailAddress
                                      .trim()
                                      .toString()
                                      .toLowerCase() ||
                                  !Helper.validateEmail(
                                    this.state.confirmEmailAddress,
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => this.confirmEmailChange(e)}
                                disabled={
                                  this.state.confirmEmailAddress &&
                                  isAutoPopulate
                                    ? true
                                    : false
                                }
                              />
                            )}
                            {this.state.authorisedEmail && (
                              <TextInput
                                tabIndex={0}
                                type="email"
                                labelText=""
                                autoComplete="off"
                                required
                                id="confirmEmailAddress"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                value={this.state.confirmEmailAddress}
                                invalid={
                                  !this.state.confirmEmailAddress.length ===
                                    0 ||
                                  this.state.subjectEmail
                                    .trim()
                                    .toString()
                                    .toLowerCase() !==
                                    this.state.confirmEmailAddress
                                      .trim()
                                      .toString()
                                      .toLowerCase() ||
                                  !Helper.validateEmail(
                                    this.state.confirmEmailAddress,
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => this.confirmEmailChange(e)}
                              />
                            )}
                          </div>
                        </div>
                        {/* ********* IBM email address ******** IBM email address(es) row **********/}
                        {(requestorType === 'Employee' ||
                          requestorType === 'Former Employee') &&
                          !this.state.authorisedEmail && (
                            <div className="bx--row">
                              <div className="bx--col-lg-8 bx--space firstName">
                                <FormLabel>
                                  {requestorType === 'Employee' &&
                                    this.state.intranetemailID && (
                                      <span className="required">*&nbsp;</span>
                                    )}
                                  <span>{t.translations.dsr.form.title12}</span>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  id="ibmEmail"
                                  autoComplete="off"
                                  placeholder={
                                    t.translations.login.emailPlaceholder
                                  }
                                  value={this.state.intranetemailID}
                                  onChange={(e) => this.ibmEmailChange(e)}
                                  disabled={
                                    this.state.intranetemailID && isGetUserData
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <div className="bx--col-lg-8 bx--space firstName">
                                <FormLabel>
                                  <Tooltip
                                    tabIndex={-1}
                                    direction="bottom"
                                    triggerText={
                                      t.translations.dsr.form.title11
                                    }
                                  >
                                    <p className="tooltipAlign">
                                      {t.translations.tooltipEmailaddresses}
                                    </p>
                                  </Tooltip>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  id="ibmEmailaddress"
                                  autoComplete="off"
                                  placeholder={
                                    t.translations.login.emailPlaceholder
                                  }
                                  value={this.state.ibmEmailaddress}
                                  onChange={(e) =>
                                    this.ibmEmailaddressChange(e)
                                  }
                                />
                              </div>
                            </div>
                          )}
                        {this.state.authorisedEmail && (
                          <div className="bx--row">
                            <div className="bx--col-lg-8 bx--space firstName">
                              <FormLabel>
                                {requestorType === 'Employee' &&
                                  this.state.intranetemailID && (
                                    <span className="required">*&nbsp;</span>
                                  )}
                                <span>
                                  {t.translations.dsr.datasubjectForm.title11}
                                </span>
                              </FormLabel>
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                id="ibmEmail"
                                autoComplete="off"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                value={this.state.intranetemailID}
                                onChange={(e) => this.ibmEmailChange(e)}
                              />
                            </div>
                            <div className="bx--col-lg-8 bx--space firstName">
                              <FormLabel>
                                <span>{t.translations.dsr.form.title11}</span>
                              </FormLabel>
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                id="ibmEmailaddress"
                                autoComplete="off"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                value={this.state.ibmEmailaddress}
                                onChange={(e) => this.ibmEmailaddressChange(e)}
                              />
                            </div>
                          </div>
                        )}
                        {/* IBM Talent ID ************* other Talent ID(s) row */}
                        {(requestorType === 'Employee' ||
                          requestorType === 'Former Employee') &&
                          !this.state.authorisedEmail && (
                            <div className="bx--row">
                              <div
                                className="bx--col-lg-8 bx--space firstName"
                                id="talentIBM"
                              >
                                <FormLabel>
                                  <span>
                                    {requestorType === 'Employee' &&
                                      this.state.serialNum &&
                                      isAutoPopulate && (
                                        <span className="required">
                                          *&nbsp;
                                        </span>
                                      )}
                                    {t.translations.dsr.form.title10}
                                  </span>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  autoComplete="off"
                                  id="talentId"
                                  placeholder="123456"
                                  value={this.state.serialNum}
                                  onChange={(e) => this.talentIdChange(e)}
                                  disabled={
                                    this.state.serialNum && isGetUserData
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <div
                                className="bx--col-lg-8 bx--space firstName"
                                id="talentIBM1"
                              >
                                <FormLabel>
                                  <Tooltip
                                    tabIndex={-1}
                                    direction="bottom"
                                    triggerText={t.translations.dsr.form.title9}
                                  >
                                    <p className="tooltipAlign">
                                      {t.translations.tooltipTalentID}
                                    </p>
                                  </Tooltip>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  autoComplete="off"
                                  id="othertalentId"
                                  placeholder=""
                                  value={this.state.inputSerialNum}
                                  onChange={(e) => this.othertalentIdChange(e)}
                                />
                              </div>
                            </div>
                          )}
                        {(requestorType === 'Employee' ||
                          requestorType === 'Former Employee') &&
                          this.state.authorisedEmail && (
                            <div className="bx--row">
                              <div
                                className="bx--col-lg-8 bx--space firstName"
                                id="talentIBM"
                              >
                                <FormLabel>
                                  <span>
                                    {requestorType === 'Employee' &&
                                      this.state.serialNum && (
                                        <span className="required">
                                          *&nbsp;
                                        </span>
                                      )}
                                    {t.translations.dsr.datasubjectForm.title9}
                                  </span>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  autoComplete="off"
                                  id="talentId"
                                  placeholder="123456"
                                  value={this.state.serialNum}
                                  onChange={(e) => this.talentIdChange(e)}
                                />
                              </div>
                              <div
                                className="bx--col-lg-8 bx--space firstName"
                                id="talentIBM1"
                              >
                                <FormLabel>
                                  <span>{t.translations.dsr.form.title9}</span>
                                </FormLabel>
                                <TextInput
                                  tabIndex={0}
                                  labelText=""
                                  autoComplete="off"
                                  id="othertalentId"
                                  placeholder=""
                                  value={this.state.inputSerialNum}
                                  onChange={(e) => this.othertalentIdChange(e)}
                                />
                              </div>
                            </div>
                          )}
                        {/* *************** Country and state dropdown row *************** */}
                        <div className="bx--row">
                          <div className="bx--col-lg-8 bx--space firstName">
                            <FormLabel>
                              <span className="required">*&nbsp;</span>
                              {!this.state.authorisedEmail && (
                                <span>{t.translations.dsr.form.title6}</span>
                              )}
                              {this.state.authorisedEmail && (
                                <span>
                                  {t.translations.dsr.datasubjectForm.title5}
                                </span>
                              )}
                            </FormLabel>
                            <Dropdown
                              id="countries"
                              selectedItem={this.state.countrySelect}
                              items={this.state.countryList}
                              onChange={({ selectedItem }) =>
                                this.countryChange(selectedItem)
                              }
                              itemToString={(item) => (item ? item.text : '')}
                              label={t.translations.dsr.choose}
                              invalid={!this.state.countrySelect ? true : false}
                            />
                          </div>
                          <div
                            className="bx--col-lg-8 bx--space firstName"
                            id="stateOfC"
                          >
                            <FormLabel>
                              {!this.state.authorisedEmail && (
                                <span>
                                  {this.state.stateList.length != 0 && (
                                    <span className="required">*&nbsp;</span>
                                  )}
                                  {t.translations.dsr.form.title7}
                                </span>
                              )}
                              {this.state.authorisedEmail && (
                                <span>
                                  {this.state.stateList.length != 0 && (
                                    <span className="required">*&nbsp;</span>
                                  )}
                                  {t.translations.dsr.datasubjectForm.title6}
                                </span>
                              )}
                            </FormLabel>
                            {this.state.stateList.length != 0 ? (
                              <Dropdown
                                id="states"
                                selectedItem={this.state.stateSelect}
                                items={this.state.stateList}
                                onChange={({ selectedItem }) =>
                                  this.stateChange(selectedItem)
                                }
                                itemToString={(item) => (item ? item.text : '')}
                                invalid={!this.state.stateSelect ? true : false}
                                label={t.translations.dsr.choose}
                              />
                            ) : (
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                autoComplete="off"
                                placeholder=""
                              />
                            )}
                          </div>
                        </div>
                        {/* *************** Authorized representative email address and
                      Confirm Authorized representative email address row *************** */}
                        {this.state.authorisedEmail && (
                          <div className="bx--row">
                            <div className="bx--col-lg-8 bx--space firstName">
                              <FormLabel>
                                <span className="required">*&nbsp;</span>
                                {t.translations.dsr.datasubjectForm.title14}
                              </FormLabel>
                              <TextInput
                                tabIndex={0}
                                labelText=""
                                type="email"
                                autoComplete="off"
                                required
                                id="authorisedEmail"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                disabled={
                                  this.state.authorisedEmail ? true : false
                                }
                                invalid={
                                  !this.state.authorisedEmail.length === 0 ||
                                  !Helper.validateEmail(
                                    this.state.authorisedEmail,
                                  )
                                    ? true
                                    : false
                                }
                                value={this.state.authorisedEmail}
                                onChange={(e) => this.emailChange(e)}
                              />
                            </div>
                            <div className="bx--col-lg-8 bx--space firstName">
                              <FormLabel>
                                <span className="required">*&nbsp;</span>
                                {t.translations.dsr.datasubjectForm.title15}
                              </FormLabel>
                              <TextInput
                                tabIndex={0}
                                type="email"
                                labelText=""
                                autoComplete="off"
                                required
                                id="confirmEmailAddress"
                                placeholder={
                                  t.translations.login.emailPlaceholder
                                }
                                value={this.state.authconfirmEmailAddress}
                                invalid={
                                  !this.state.authconfirmEmailAddress.length ===
                                    0 ||
                                  this.state.authorisedEmail
                                    .trim()
                                    .toString()
                                    .toLowerCase() !==
                                    this.state.authconfirmEmailAddress
                                      .trim()
                                      .toString()
                                      .toLowerCase() ||
                                  !Helper.validateEmail(
                                    this.state.authconfirmEmailAddress,
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => this.confirmauthEmailChange(e)}
                              />
                            </div>
                          </div>
                        )}
                        {/* ************* Additional information row *************** */}
                        <div className="bx--row">
                          <div className="bx--col-lg-16 additionalInfo">
                            <FormLabel className="wordCount_wrap">
                              {t.translations.dsr.form.title8}
                              <span className="wordCount">
                                {wardCountStartAi}/1000
                              </span>
                            </FormLabel>
                            <TextArea
                              helperText=""
                              rows={4}
                              cols={82}
                              maxLength={1000}
                              id="text-area-1"
                              value={additionalInformation}
                              onChange={(e) =>
                                this.onChangeAdditionalInformation(e)
                              }
                            />
                          </div>
                        </div>
                        {/* Submit ************* cancel button row */}
                        <div className="bx--row ButtonRow">
                          <div className="buttonDiv1"></div>
                          <Button
                            kind="primary"
                            onClick={(e) => this.handleDataRightsRequestForm(e)}
                            disabled={this.state.enableButton}
                            type="submit"
                          >
                            {t.translations.dsr.buttonSubmit}
                          </Button>
                          <div className="buttonDiv2"></div>
                          <div>
                            <Button
                              kind="secondary"
                              onClick={() => this.cancelForm()}
                            >
                              {t.translations.dsr.buttonCancel}
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
                <div className="bx--col-sm-4 bx--col-lg-6 buttonDiv1">
                  <ToastNotification
                    kind="info"
                    title={t.translations.dsr.infotitle}
                    caption=""
                    className="toastDiv"
                  >
                    {t.translations.dsr.infoline1} <br />
                    {t.translations.dsr.infoline2}{' '}
                    <Link href={`${t.translations.commonLinks.docsLink}`}>
                      {t.translations.dsr.infolink}
                    </Link>
                    <br />
                    <br />
                  </ToastNotification>
                  <br />
                  <p className="noteFont">{t.translations.footerMsg}</p>
                  <br />
                  {this.state.authorisedEmail && (
                    <p className="noteFont">
                      <h5>{t.translations.dsr.form.note}</h5>
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg1}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg2}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg3}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg4}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg5}
                      <br />
                      <br />

                      {t.translations.dsr.datasubjectForm.notemsg6}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg7}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg8}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg9}
                      <br />
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg10}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg11}
                      <br />
                      {t.translations.dsr.datasubjectForm.notemsg12}
                      <br />
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        className="noteFont"
                        href={`${t.translations.commonLinks.addDsrLink}`}
                      >
                        {t.translations.dsr.datasubjectForm.notelink}
                      </Link>
                    </p>
                  )}
                  {!this.state.authorisedEmail && (
                    <p className="noteFont">
                      <h5>{t.translations.dsr.form.note}</h5>
                      <br />
                      {t.translations.dsr.form.notemsg1}
                      <br />
                      {t.translations.dsr.form.notemsg2}
                      <br />
                      {t.translations.dsr.form.notemsg3}
                      <br />
                      {t.translations.dsr.form.notemsg4}
                      <br />
                      {t.translations.dsr.form.notemsg5}
                      <br />
                      {t.translations.dsr.form.notemsg6}
                      <br />
                      {t.translations.dsr.form.notemsg7}
                      <br />
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        className="noteFont"
                        href={`${t.translations.commonLinks.addDsrLink}`}
                      >
                        {t.translations.dsr.form.notelink}
                      </Link>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <br />
      </div>
    );
  }
}
export default DsrComponent;
